export var EDirectionOfEffect;
(function (EDirectionOfEffect) {
    EDirectionOfEffect["Increase"] = "Increase";
    EDirectionOfEffect["Decrease"] = "Decrease";
    EDirectionOfEffect["NoDirectionOfEffect"] = "-";
})(EDirectionOfEffect || (EDirectionOfEffect = {}));
